import PaintRawMaterialsWorkspace from '../../placeholders/PaintRawMaterialsWorkspace';

export default PaintRawMaterialsWorkspace;
